import {
  library,
} from '@fortawesome/fontawesome-svg-core'
import {
  faEarthAfrica,
  faRightLeft,
  faSliders,
  faFaceFrownSlight,
  faPaperPlane,
  faBusSimple,
} from '@fortawesome/pro-solid-svg-icons'

export default defineNuxtPlugin(() => {
  library.add({
    faEarthAfrica,
    faRightLeft,
    faSliders,
    faFaceFrownSlight,
    faPaperPlane,
    faBusSimple,
  })
})
